"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PickrHandle = exports.UI = exports.Click = exports.Tool = exports.Move = void 0;
var Move;
(function (Move) {
    Move[Move["Ignore"] = 0] = "Ignore";
    Move[Move["Allow"] = 1] = "Allow";
    Move[Move["Tracking"] = 2] = "Tracking";
})(Move || (exports.Move = Move = {}));
var Tool;
(function (Tool) {
    Tool[Tool["Paint"] = 0] = "Paint";
    Tool[Tool["SpinR"] = 1] = "SpinR";
    Tool[Tool["FlipH"] = 2] = "FlipH";
    Tool[Tool["SpinL"] = 3] = "SpinL";
    Tool[Tool["FlipV"] = 4] = "FlipV";
})(Tool || (exports.Tool = Tool = {}));
var Click;
(function (Click) {
    Click[Click["Ignore"] = 0] = "Ignore";
    Click[Click["Allow"] = 1] = "Allow";
})(Click || (exports.Click = Click = {}));
class UI {
    tabs = null;
    colorEvents = Click.Allow;
    colorTemplate = null;
    borderTemplate = null;
    guides;
    paintColors = [1, 0];
    selectedTool = Tool.Paint;
    moveStatus = Move.Allow;
    toolClass = "";
    setCursor(target, name) {
        if (this.toolClass !== "") {
            target.classList.remove(this.toolClass);
        }
        if (name !== "") {
            target.classList.add(name);
            this.toolClass = name;
        }
    }
}
exports.UI = UI;
class PickrHandle {
    handle;
    saved;
    constructor(handle, saved) {
        this.handle = handle;
        this.saved = saved;
    }
    saveColor(newColor) {
        this.saved = newColor;
        this.handle.applyColor(true);
    }
}
exports.PickrHandle = PickrHandle;
